import {
    addSubStepAttachment,
    deleteSubStepAttachment,
    getAllTesterAppVersionDetails,
    updateValidationSubStepStatus,
    updateMediaStatus,
    updateValidationStatus,
    downloadSubStepAttachment,
    updatePermissionValidation,
} from "@app/redux/services/validation";
import { Dispatch } from "redux";
import {
    ADD_ATTACHMENT,
    DELETE_ATTACHMENT,
    SET_VALIDATION_LIST,
    UPDATE_REPORT_STATUS,
    UPDATE_VALIDATION_STATUS,
    UPDATE_MEDIA_STATUS,
    UPDATE_MEDIA_IMAGE_STATUS,
    UPDATE_API_FETCHING,
    SAVE_PERMISSION_VALIDATION,
} from "./types";
import TokenService from "@app/redux/services/token";

export const getTesterAppVersionDetails =
    (appId: string) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await getAllTesterAppVersionDetails(appId);

            dispatch({
                type: SET_VALIDATION_LIST,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const updateValidationStepStatus =
    (id: string, data: any) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await updateValidationSubStepStatus(id, data);

            dispatch({
                type: UPDATE_VALIDATION_STATUS,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const updateMediaItemStatus =
    (id: string, data: any, itemStatus: object) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await updateMediaStatus(id, data);

            dispatch({
                type: UPDATE_MEDIA_STATUS,
                payload: response.data,
            });

            dispatch({
                type: UPDATE_MEDIA_IMAGE_STATUS,
                payload: {
                    itemStatus,
                },
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const updateValidationReportStatus =
    (id: string, data: any) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await updateValidationStatus(id, data);

            dispatch({
                type: UPDATE_REPORT_STATUS,
                payload: {
                    status: response.data.data.status,
                },
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const addValidationStepAttachment =
    (
        id: string,
        data: any,
        onProgress: (event: ProgressEvent<EventTarget>, data: unknown) => void
    ) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await addSubStepAttachment(id, data, onProgress);

            dispatch({
                type: ADD_ATTACHMENT,
                payload: {
                    data: response.data.data,
                    step_id: data.get("step_id"),
                    sub_step_id: data.get("sub_step_id"),
                },
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const deleteValidationStepAttachment =
    (data: any) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await deleteSubStepAttachment(data.id);

            dispatch({
                type: DELETE_ATTACHMENT,
                payload: {
                    data: response.data.data,
                    step_id: data.step_id,
                    sub_step_id: data.sub_step_id,
                    id: data.id,
                },
            });

            return Promise.resolve(response.data);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const downloadValidationStepAttachment = (id: string) => async (): Promise<any> => {
    try {
        const response = await downloadSubStepAttachment(id);
        // dispatch({
        //     type: ADD_ATTACHMENT,
        //     payload: {
        //         data: response.data.data
        //     }
        // })
        return Promise.resolve(response);
    } catch (err: any) {
        return Promise.reject(err);
    }
};


export const updatePermissionValidationList =
    (id: string, data: any) =>
    async (dispatch: Dispatch): Promise<any> => {
        try {
            const response = await updatePermissionValidation(id, {
                permissionList: data[id],
            });
            dispatch({
                type: SAVE_PERMISSION_VALIDATION,
                payload: {
                    data,
                },
            });
            return Promise.resolve(response);
        } catch (err: any) {
            return Promise.reject(err);
        }
    };

export const resetPermissionValidationList = () => (dispatch: Dispatch) => {
    dispatch({
        type: SAVE_PERMISSION_VALIDATION,
        payload: {
            data: {},
        },
    });
};
